const dedicatedfoodList = {
  getlist: 'specialdietfoodlist/getlist',
  add: 'specialdietfoodlist/add',
  update: 'specialdietfoodlist/update',
  remove: 'specialdietfoodlist/remove',
  get: 'specialdietfoodlist/get',
  getall: 'specialdietfoodlist/getall',
}
export default dedicatedfoodList
